import React, {
	createContext,
	type ComponentType,
	type ReactNode,
} from "react";
import type { NavbarRendererProps } from "./components/navigation/NavbarMenuBar";
import type { AppReleaseApp } from "./configuration/pages/appReleases/models/AppRelease";
import { ConfigurationsType } from "./configurationMenu";

const RouterContext = createContext<() => ReactNode>(() => <></>);
const ConfigurationContext = createContext<ConfigurationsType>([
	[],
	() => <></>,
]);
const NavbarContext = createContext<ComponentType<NavbarRendererProps>>(() => (
	<></>
));
const OperatorsFeatureContext = createContext<boolean>(false);
const EmailTopicsFeatureContext = createContext<boolean>(false);
/** Mobile apps managed from the App Releases page. Empty disables the feature. */
const AppReleasesFeatureContext = createContext<AppReleaseApp[]>([]);

export {
	RouterContext,
	ConfigurationContext,
	NavbarContext,
	OperatorsFeatureContext,
	EmailTopicsFeatureContext,
	AppReleasesFeatureContext,
};
